import React from "react";
import Bootstrap from "./features/bootstrap/Bootstrap";
import Loading from "./components/dataTable/Loading";
import SessioneInScadenza from "./features/SessioneInScadenza";
import SessioneScaduta from "./features/SessioneScaduta";
import {AppHRProps} from "./App";
import {queryClient} from "@utilities/config.ReactQuery";
import {QueryClientProvider} from "@tanstack/react-query";
import {Pianificazione} from "./pages/presenze/pianificazione/pianificazione";
import AziendaNavContainer from "./features/azienda/AziendaNavContainer";

// Ho la necessità di includere uno script iframeResizer.contentWindow.js, come nel post, ho provato diverse strade (anche Helmet...) ma alla fine era sufficiente importarlo "normalmente"
//https://stackoverflow.com/questions/34424845/adding-script-tag-to-react-jsx
//https://stackoverflow.com/questions/55723467/how-do-i-use-iframe-resizer-with-a-react-js-page-as-content
import "iframe-resizer/js/iframeResizer.contentWindow";

const AppPianificazione: React.FC<AppHRProps> = ({isBoot, isRunning, isTrust, appState, minutiDiInattivita}) => {
    const sfondo = {
        "background": `url('${process.env.PUBLIC_URL}/images/banner-img.jpg')`,
        "backgroundSize": "cover",
        "backgroundRepeat": "no-repeat",
        "backgroundPosition": "center",
    }

    return (
        <>
            {isBoot && <Bootstrap/>}
            {!isBoot && <>
                {!isRunning &&
                    <div className="bg-gray-100">
                    </div>
                }
                {isRunning &&
                    <div className="bg-gray-100 p-1 sm:text-sm">
                        {/*<Helmet>
                            <script src={`url('${process.env.PUBLIC_URL}/scripts/iframeResizer.contentWindow.js')`}></script>
                        </Helmet>*/}
                        <Loading loading={appState === 'ISEXPIRING' || appState === 'EXPIRED'}
                                 spinner={appState === 'ISEXPIRING' ? <SessioneInScadenza/> : <SessioneScaduta/>}>
                            <QueryClientProvider client={queryClient}>
                                {/*<ReactQueryDevtools initialIsOpen={false}/>*/}
                                <AziendaNavContainer onNavSetIsBusy={true}>
                                    <Pianificazione/>
                                </AziendaNavContainer>
                                <div data-iframe-height=""></div>
                            </QueryClientProvider>
                        </Loading>
                    </div>
                }
            </>
            }
        </>
    );
}
export default AppPianificazione;